import * as React from 'react';
import { FC } from 'react';
import Field from './Field';
import type { FieldProps } from './Field';
import { useContext } from './useFormContext';

const RowTarget: FC<Pick<FieldProps, 'validation' | 'updateValidationState'>> = ({
  validation,
  updateValidationState,
}) => {
  const { locales } = useContext();

  return (
    <Field
      label={locales.target_label}
      name="target"
      validation={validation}
      updateValidationState={updateValidationState}
      placeholder={locales.target_placeholder}
      hint={locales.hint}
    />
  );
};

export default RowTarget;
